import { render, staticRenderFns } from "./SectionStatements.vue?vue&type=template&id=d3edcfbc&"
import script from "./SectionStatements.vue?vue&type=script&lang=js&"
export * from "./SectionStatements.vue?vue&type=script&lang=js&"
import style0 from "./SectionStatements.vue?vue&type=style&index=0&id=d3edcfbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrganismsCommonOrganismStatementsSlider: require('/app/components/organisms/common/OrganismStatementsSlider.vue').default})
